import { groupByExperiments } from './groupByExperiments';
import { convertOneExperiment } from './util/convertOneExperiment.js';

/**
 *
 * @param {*} fileList
 * @param {object} [options={}]
 * @param {object} [options.filter]
 * @param {object} [options.converter]
 * @returns
 */
export async function convertFileList(fileList, options = {}) {
  const { filter, converter } = options;
  const results = [];
  const experiments = groupByExperiments(fileList, filter);
  for (let experiment of experiments) {
    const result = await convertOneExperiment(experiment, converter);
    if (result) {
      results.push(result);
    }
  }
  return results;
}
